var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.isClicked)?_c('div',{staticClass:"wrapper flex"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"flex"},[_c('p',[_vm._v("😇")]),_vm._v(" Klicke bitte oben rechts in der Link-Leiste auf die drei Punkte (●●●) und dann auf \"Im Browser öffnen\". So funktioniert heyJura auch über Instagram. ")])])
}]

export { render, staticRenderFns }